// Mirrors api/src/common/payment-grace.util.ts (docs/payment-grace-period.md). The API sends
// paymentGraceEndsAt, so the 7-day arithmetic lives only on the server.

/** When a failed-card account loses access (ms), or null when it is not in a failed-card grace. */
export function paymentGraceEndsAt(user) {
  if (user?.accessStatus !== 'payment_failed' || !user.paymentGraceEndsAt) return null;
  const endsAt = Date.parse(user.paymentGraceEndsAt);
  return Number.isNaN(endsAt) ? null : endsAt;
}

/** True for a current customer: paid/trialling, or a failed card still inside its 7-day grace. */
export function hasContentAccess(user, now = Date.now()) {
  if (user?.accessStatus === 'has_access') return true;
  const endsAt = paymentGraceEndsAt(user);
  return endsAt !== null && now < endsAt;
}
